var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHyperlink(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_14388_103618)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.6663 1.33301H2.33301C1.78072 1.33301 1.33301 1.78072 1.33301 2.33301V11.6663C1.33301 12.2186 1.78072 12.6663 2.33301 12.6663H11.6663C12.2186 12.6663 12.6663 12.2186 12.6663 11.6663V2.33301C12.6663 1.78072 12.2186 1.33301 11.6663 1.33301Z",
    stroke: "#8B93A7",
    strokeWidth: 0.875,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.14551 5.70282L7.90967 3.86632C8.39354 3.38242 9.18874 3.39308 9.68577 3.89012C10.1828 4.38715 10.1935 5.18235 9.70957 5.66622L9.07287 6.34048",
    stroke: "#8B93A7",
    strokeWidth: 0.875,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.4854 7.58276C4.3153 7.75286 3.96357 8.09253 3.96357 8.09253C3.47967 8.5764 3.46654 9.43886 3.96357 9.9359C4.4606 10.4329 5.25577 10.4436 5.73967 9.9597L7.46107 8.3969",
    stroke: "#8B93A7",
    strokeWidth: 0.875,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.21774 7.44309C5.98688 7.21223 5.86094 6.91703 5.84078 6.61856C5.81751 6.27449 5.93481 5.92609 6.19394 5.66699",
    stroke: "#8B93A7",
    strokeWidth: 0.875,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.4375 6.62061C7.93453 7.11764 7.9452 7.91284 7.4613 8.39671",
    stroke: "#8B93A7",
    strokeWidth: 0.875,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_14388_103618"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 14,
    height: 14,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHyperlink);
export default __webpack_public_path__ + "static/media/hyperlink.102d2d7435c8aa5935e5608c0e4658c3.svg";
export { ForwardRef as ReactComponent };